export const SET_CURRENT_CONVERSATION = "SET_CURRENT_CONVERSATION";
export const FETCH_TOTAL_UNREAD_INIT = "FETCH_TOTAL_UNREAD_INIT";
export const FETCH_TOTAL_UNREAD_SUCCESS = "FETCH_TOTAL_UNREAD_SUCCESS";
export const SEND_BIRD_INIT = "SEND_BIRD_INIT";
export const SEND_BIRD_SUCCESS = "SEND_BIRD_SUCCESS";
export const SET_ALL_CONVERSATIONS = "SET_ALL_CONVERSATIONS";
export const SET_ENQUIRE_MESSAGE = "SET_ENQUIRE_MESSAGE";
